import { createBrowserOnlyLazyComponent } from '@dbh/react-lazy';

var index = createBrowserOnlyLazyComponent(()=>import('./component-19d4e10b.js'/* webpackChunkName: "dbh.hotel-other-services-entry-content" */));

export { index as default };
